import { Box, Typography } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipConditionalDiscount = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <Typography variant="body1">
                    Desconto que depende de um evento futuro (ex: pagamento antecipado pelo cliente). 
                    Este valor não reduz a base de cálculo dos impostos no momento da emissão.
                </Typography>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipConditionalDiscount;